// src/pages/Files.js
import React from 'react';

const Files = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-2">Files</h2>
      <p>This is the Files page. You’ll find all uploaded documents and assets here.</p>
    </div>
  );
};

export default Files;